(ns ui.view.transaction-process.modals.attestation.sub
  (:require
   [common.schema.entities.attestation-condition :as attestation-condition]
   [re-frame.core :as rf]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.sub :as tp-sub]
   [ui.view.transaction-process.util :as tp-util]))

(rf/reg-sub
 ::form
 (fn [db [_ {:keys [state-path] :as _ctx}]]
   (get-in db (common/form-full-path state-path))))

(defn- form-signal [[_ ctx]]
  [(rf/subscribe [::form ctx])])

(rf/reg-sub
 ::edit-mode?
 form-signal
 (fn [[f]]
   (:edit-mode? f)))

(rf/reg-sub
 ::submitting?
 form-signal
 (fn [[f]]
   (:submitting? f)))

(rf/reg-sub
 ::error
 form-signal
 (fn [[f]]
   (:error f)))

(rf/reg-sub
 ::type-label
 form-signal
 (fn [[f]]
   (:attestation-type-label f)))

(rf/reg-sub
 ::outcome
 form-signal
 (fn [[f]]
   (:attestation/outcome f)))

(rf/reg-sub
 ::date
 form-signal
 (fn [[f]]
   (:attestation/date f)))

(rf/reg-sub
 ::comment
 form-signal
 (fn [[f]]
   (:attestation/comment f)))

(rf/reg-sub
 ::conditions
 form-signal
 (fn [[f]]
   (:conditions f)))

(rf/reg-sub
 ::pending-files
 form-signal
 (fn [[f]]
   (:pending-files f)))

(rf/reg-sub
 ::entity-id
 form-signal
 (fn [[f]]
   (:entity-id f)))

(rf/reg-sub
 ::entry
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/template ctx])])
 (fn [[form template]]
   (tp-util/dictionary-entry template (:slot-kw form))))

(rf/reg-sub
 ::slot-template
 (fn [[_ ctx]] [(rf/subscribe [::entry ctx])])
 (fn [[entry]]
   (:slot/template entry)))

(rf/reg-sub
 ::outcome-options
 (fn [[_ ctx]] [(rf/subscribe [::entry ctx])])
 (fn [[entry]]
   (tp-util/attestation-outcome-options entry)))

(rf/reg-sub
 ::field-configs
 (fn [[_ ctx]] [(rf/subscribe [::tp-sub/template ctx])])
 (fn [[template]]
   (:template/fields template)))

(rf/reg-sub
 ::context-fields
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/template ctx])])
 (fn [[form template]]
   (get (:template/attestation-context-fields template) (:slot-kw form) [])))

(rf/reg-sub
 ::detail-fields
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/template ctx])])
 (fn [[form template]]
   (get (:template/attestation-detail-fields template) (:slot-kw form) [])))

(rf/reg-sub
 ::date-visible?
 ;; Whether this attestation slot renders a date field — derived from the slot
 ;; template (the Lux slot omits :attestation/date).
 (fn [[_ ctx]] [(rf/subscribe [::slot-template ctx])])
 (fn [[slot-template]]
   (boolean (some #{:attestation/date} (tp-util/template-value-fields slot-template)))))

(rf/reg-sub
 ::mandatory-fields
 ;; The currently-mandatory field-kws, derived from the template field-configs
 ;; over the slot template's in-scope value-fields. Single source for the modal
 ;; asterisks (and it agrees with ::ready-errors, which walks the same configs).
 (fn [[_ ctx]]
   [(rf/subscribe [::slot-template ctx])
    (rf/subscribe [::field-configs ctx])
    (rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/process ctx])])
 (fn [[slot-template field-configs form process]]
   (->> (tp-util/template-value-fields slot-template)
        (filter #(tp-util/field-mandatory? (get field-configs %) (merge process form)))
        set)))

(rf/reg-sub
 ::conditions-visible?
 (fn [[_ ctx]]
   [(rf/subscribe [::entry ctx])
    (rf/subscribe [::outcome ctx])])
 (fn [[entry outcome]]
   (tp-util/attestation-requires-conditions? entry outcome)))

(rf/reg-sub
 ::ready-errors
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::slot-template ctx])
    (rf/subscribe [::field-configs ctx])
    (rf/subscribe [::tp-sub/process ctx])])
 (fn [[form slot-template field-configs process]]
   (tp-util/attestation-ready-errors
    {:field-configs field-configs
     :slot-template slot-template
     :values        form
     :conditions    (:conditions form)
     :process       process})))

(rf/reg-sub
 ::condition-status-options
 ;; Sourced from the attestation-condition schema enum — one definition for the
 ;; modal select and the read views, in TP's {:value :label} input shape.
 (fn [_ _]
   (tp-util/schema-opts->input-opts attestation-condition/condition-status-options)))

(rf/reg-sub
 ::save-draft-disabled?
 (fn [[_ ctx]] [(rf/subscribe [::outcome ctx])])
 (fn [[outcome]]
   (not outcome)))
